import { db } from '~/db/db';

export async function updateConvertedClient(prospectId, recebedorId) {
  const origemId = Number(prospectId);
  const destinoId = Number(recebedorId);

  if (!Number.isInteger(origemId) || origemId <= 0 || !Number.isInteger(destinoId) || destinoId <= 0 || origemId === destinoId) return;
  const tables = [db.funilObra, db.funilObraDashboard, db.simulacoes, db.simuladorSimulacoes];

  await db.transaction('rw', tables, async () => {
    for (const table of tables) {
      await table.where('clienteId').anyOf([origemId, String(origemId)])
        .modify({ clienteId: destinoId });
    }
  });
}
